import { render, staticRenderFns } from "./IndustryList.vue?vue&type=template&id=928044f6&scoped=true"
import script from "./IndustryList.vue?vue&type=script&lang=js"
export * from "./IndustryList.vue?vue&type=script&lang=js"
import style0 from "./IndustryList.vue?vue&type=style&index=0&id=928044f6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928044f6",
  null
  
)

export default component.exports